import React from 'react';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        // You might log this to an external service
        // console.error('ErrorBoundary caught', error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: 16, border: '1px solid #f5c6cb', background: '#fff1f2', borderRadius: 4 }}>
                    <strong>Preview failed to render.</strong>
                    <div style={{ marginTop: 8 }}>
                        The HTML preview encountered an error. You can view the raw HTML in the editor tab.
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
